"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExternalVideoMetadataSchema = exports.ExternalVideoProviderSchema = void 0;
exports.isExternalVideoIdValid = isExternalVideoIdValid;
exports.externalVideoWatchUrl = externalVideoWatchUrl;
exports.externalVideoEmbedUrl = externalVideoEmbedUrl;
const zod_1 = require("zod");
exports.ExternalVideoProviderSchema = zod_1.z.enum(['youtube', 'vimeo']);
const providerVideoIdSchemas = {
    youtube: zod_1.z.string().regex(/^[A-Za-z0-9_-]{11}$/, 'invalid YouTube video id'),
    vimeo: zod_1.z.string().regex(/^[0-9]{6,12}$/, 'invalid Vimeo video id'),
};
/**
 * Shared, URL-free external-video metadata. Public renderers derive provider
 * URLs from this contract; callers can never persist an arbitrary iframe URL.
 */
exports.ExternalVideoMetadataSchema = zod_1.z
    .object({
    provider: exports.ExternalVideoProviderSchema,
    videoId: zod_1.z
        .string()
        .min(3)
        .max(64)
        .regex(/^[A-Za-z0-9_-]+$/, 'invalid external video id'),
    autoplay: zod_1.z.boolean().default(false),
    caption: zod_1.z.string().max(280).optional(),
})
    .strict();
function isExternalVideoIdValid(video) {
    return providerVideoIdSchemas[video.provider].safeParse(video.videoId)
        .success;
}
function externalVideoWatchUrl(video) {
    return video.provider === 'youtube'
        ? `https://www.youtube.com/watch?v=${encodeURIComponent(video.videoId)}`
        : `https://vimeo.com/${encodeURIComponent(video.videoId)}`;
}
function externalVideoEmbedUrl(video) {
    const autoplay = video.autoplay ? '1' : '0';
    return video.provider === 'youtube'
        ? `https://www.youtube-nocookie.com/embed/${encodeURIComponent(video.videoId)}?autoplay=${autoplay}`
        : `https://player.vimeo.com/video/${encodeURIComponent(video.videoId)}?autoplay=${autoplay}`;
}
